import React from "react";
import { Col, Row } from "react-bootstrap";
import { fadeIn } from "../../Functions/GlobalAnimations";
import { m } from "framer-motion";
import ImageGallery from "../../Components/ImageGallery/ImageGallery";
import { useQuery } from "@tanstack/react-query";
import { getMediaGallery } from "../../Store/Publication/gallery";
import Loading from "../../Components/Loading";

const KeraInMedia = () => {
  const mediaGalleryData = [
    { src: "/images/Agro Park.webp", title: "Agro Park Media" },
    { src: "/images/IMG-20250711-WA0005.webp", title: "Press Meet" },
    { src: "/images/IMG-20250711-WA0007.webp", title: "Coverage 1" },
    { src: "/images/IMG-20250716-WA0007.webp", title: "Coverage 2" },
    { src: "/images/IMG-20250716-WA0038.webp", title: "Event Highlights" },
    {
      src: "/images/WhatsApp Image 2025-07-30 at 9.14.35 AM.jpeg.webp",
      title: "KERA in News",
    },
  ];

  const { data: media, isLoading } = useQuery({
    queryKey: ["mediaGallery"],
    queryFn: () => getMediaGallery(),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });

  if (isLoading) return <Loading />;

  return (
    <>
      <m.div className="container mt-[200px]">
        <Col xl={8} lg={10} className="text-start w-fit">
          <h3 className="font-serif text-[30px] mb-[2px] font-medium text-[#146084] ">
            KERA in Media
          </h3>
          <m.div
            className="border-b border-1 w-[40%] border-[#146084]"
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          />
          <p className="text-[16px] text-[#666] mt-4">
            A curated collection of media features, press coverage, and event
            highlights related to KERA.
          </p>
        </Col>

        <Row className="mt-[100px]">
          <Col>
            <m.div {...fadeIn}>
              <Row>
                {media?.data?.map((item, index) => (
                  <>
                    <Col
                      lg={4}
                      md={6}
                      sm={12}
                      key={index}
                      className="mb-[30px]"
                    >
                      <m.div
                        {...fadeIn}
                        transition={{ delay: index * 0.1 }}
                        className="bg-white rounded-lg overflow-hidden"
                      >
                        <div className="relative overflow-hidden">
                          <img
                            src={`https://kera.enfonoerp.com/${item?.image}`}
                            alt={item.title}
                            className="w-full h-[250px] object-cover hover:scale-105 transition-transform duration-300"
                          />
                          <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
                        </div>
                        <p className="text-[14px] text-[#666] leading-relaxed mb-3 line-clamp-3">
                          {item.description}
                        </p>
                      </m.div>
                    </Col>
                  </>
                ))}
              </Row>
            </m.div>
          </Col>
        </Row>
      </m.div>
    </>
  );
};

export default KeraInMedia;
